import React, { useEffect, useState } from 'react'
import { HeaderMenu } from '../../component/HeaderMenu'
import './MantenedorCuentas.css'
import { MantenedorContainer } from './mantenedor/MantenedorContainer'
import { CrudAdministrativo } from '../../api/admin/CrudAdministrativo.api'
import { CrudUsers } from '../../api/admin/CrudUsers.api'
import LoaderData from '../../component/LoaderData'


export const MantenedorCuentas = () => {
    const [IsLoadding, setIsLoadding] = useState(false);
    const [PageSelected, setPageSelected] = useState("START");
    const [AdminPrecargados, setAdminPrecargados] = useState([]);

    // precarga de administrativos y usuarios
    const precarga = async () => {
        setIsLoadding(true);
        let respAdmin = await CrudAdministrativo({ action: "READ" })
        // console.log(respAdmin)
        await setAdminPrecargados(respAdmin);
        await setIsLoadding(false);
    }

    useEffect(() => {
        precarga()
        return () => {
            precarga();
        }
    }, [])
    
    return (
        <>
            <HeaderMenu Pag_Sel={'/mantenedor'} />
            <div className='container-fluid'>
                <div className='row'>
                    {/* header */}
                    <div className='col-12 my-2 pt-2'></div>
                    {/* aside */}
                    <div className='col-12 col-md-3'>
                        <div className='row px-3'>
                            <div
                                onClick={() => setPageSelected("ADMINISTRATIVOS")}
                                className={PageSelected==="ADMINISTRATIVOS"?
                                'col-4 col-md-12 d-flex py-4 my-2 align-items-center justify-content-center text-white py-3 admin-menu-card-selected'
                                :'col-4 col-md-12 d-flex py-4 my-2 align-items-center justify-content-center text-white py-3 admin-menu-card-oscuro admin-menu-card-rojo'}>
                                <span className='lead'><b>ADMINISTRATIVOS</b></span>
                            </div>
                            <div
                                onClick={() => setPageSelected("SOLICITUDES")}
                                className={PageSelected==="SOLICITUDES"?
                                'col-4 col-md-12 d-flex py-4 my-2 align-items-center justify-content-center text-white py-3 admin-menu-card-selected'
                                :'col-4 col-md-12 d-flex py-4 my-2 align-items-center justify-content-center text-white py-3 admin-menu-card-oscuro admin-menu-card-rojo'
                                }>
                                <span className='lead'><b>SOLICITUDES</b></span>
                            </div>
                            <div
                                onClick={() => setPageSelected("USUARIOS")}
                                className={PageSelected==="USUARIOS"?
                                'col-4 col-md-12 d-flex py-4 my-2 align-items-center justify-content-center text-white py-3 admin-menu-card-selected'
                                :'col-4 col-md-12 d-flex py-4 my-2 align-items-center justify-content-center text-white py-3 admin-menu-card-oscuro admin-menu-card-rojo'}>
                                <span className='lead'><b>PASAJERO</b></span>
                            </div>
                        </div>
                    </div>
                    {/* content */}
                    <div className='col-12 col-md-9 p-0 m-0 py-2' style={{height: '90vh', overflowY: 'scroll'}}>
                        <MantenedorContainer PageSelected={PageSelected} datosPrecargados={AdminPrecargados} />
                    </div>
                </div>
            </div>
            {IsLoadding && <LoaderData />}
        </>
    )
}
